<ng-container *ngIf="currentStep === 0">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      Text Message Notifications
    </h4>
  </div>
  <div class="modal-body pb-0">
    Would you like to receive text message notifications?
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-success my-2"
      (click)="showInputForm()"
    >
      Yes
    </button>
    <button type="button" class="btn btn-light my-2" (click)="dismiss.emit()">
      No
    </button>
  </div>
</ng-container>

<ng-container *ngIf="currentStep === 1">
  <div class="modal-header">
    <h4 class="modal-title">Enter Phone Number</h4>
  </div>
  <div class="modal-body pb-0">
    <p>
      <span>Enter your phone number to continue.</span><br />
      <span>*message rates may apply.</span>
    </p>
    <app-dynamic-form
      [fields]="inputFields"
      [form]="inputForm"
    ></app-dynamic-form>
  </div>
  <div class="modal-footer pb-3">
    <button type="button" class="btn btn-danger" (click)="dismissModal()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-success"
      [disabled]="inputForm.invalid"
      (click)="sendCodeToPhone()"
    >
      Send Code
    </button>
  </div>
</ng-container>

<ng-container *ngIf="currentStep === 2">
  <div class="modal-header">
    <h4 class="modal-title">Send Code</h4>
  </div>
  <div class="modal-body pb-0">
    <p class="mb-0" *ngIf="type === 'email'; else phoneBody">
      You must confirm your new email. Press send code to email the code.
    </p>
    <ng-template #phoneBody>
      <p>
        <span>
          You must confirm your new phone number. Press send code to send the
          code.
        </span>
        <br />
        <span>*message rates may apply.</span>
      </p>
    </ng-template>
    <div class="text-danger" *ngIf="error">{{ error }}</div>
  </div>
  <div class="modal-footer pb-3">
    <button type="button" class="btn btn-success" (click)="sendCode()">
      Send Code
    </button>
    <button type="button" class="btn btn-danger" (click)="dismissModal()">
      Cancel
    </button>
  </div>
</ng-container>

<ng-container *ngIf="currentStep === 3">
  <div class="modal-header">
    <h4 class="modal-title" *ngIf="type === 'phone'">Verify Phone Number</h4>
    <h4 class="modal-title" *ngIf="type === 'email'">Verify Email</h4>
  </div>
  <div class="modal-body pt-1 pb-0">
    <app-dynamic-form [fields]="fields" [form]="codeForm"></app-dynamic-form>
    <div class="text-center">
      <button
        type="button"
        class="btn btn-link resend-btn"
        [disabled]="resendCooldown > 0"
        (click)="sendCode()"
      >
        <ng-container *ngIf="resendCooldown > 0; else resendText">
          You can resend code in {{ resendCooldown }}s
        </ng-container>
        <ng-template #resendText>Resend Code</ng-template>
      </button>
    </div>
    <div class="text-danger" *ngIf="error">{{ error }}</div>
  </div>
  <div class="modal-footer pb-3">
    <button
      type="button"
      class="btn btn-success"
      (click)="verifyCode()"
      [disabled]="!codeForm.valid"
    >
      Verify
    </button>
    <button type="button" class="btn btn-danger" (click)="dismissModal()">
      Cancel
    </button>
  </div>
</ng-container>

<ng-container *ngIf="currentStep === 4">
  <div class="modal-header">
    <h4>Verification Complete</h4>
  </div>
  <div class="modal-body">
    <p>Your phone number has been successfully added to your acccount</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="finishFlow()">
      Close
    </button>
  </div>
</ng-container>
